export enum TRIP_REPORT_STATUS {
  FLAGGED = 'Flagged',
  RESOLVED = 'Resolved',
  UNFLAGGED = 'Unflagged',
}

export enum TRIP_REPORT_STATUS_ID {
  ALL = 1,
  FLAGGED = 2,
  RESOLVED = 3,
  UNFLAGGED = 4,
}

export const tripReportStatusList = [
  { id: TRIP_REPORT_STATUS_ID.ALL, text: 'All' },
  { id: TRIP_REPORT_STATUS_ID.FLAGGED, text: 'Flagged' },
  { id: TRIP_REPORT_STATUS_ID.RESOLVED, text: 'Resolved' },
  { id: TRIP_REPORT_STATUS_ID.UNFLAGGED, text: 'Unflagged' },
];

export enum TRIP_LEG_REPORT_STATUS {
  UNSUBMITTED = 'Unsubmitted',
  PENDING = 'Pending',
  SUBMITTED = 'Submitted'
}

export const TRIP_REPORT_COMMENT_MAX_LENGTH = 2500;

export interface ITripReportLegData {
  tripId: number;
  tripDisplayName: string;
  departureDate: string;
  departureTime: string;
  leg: string;
  route: string;
  operator: string;
  tailNumber: string;
  client: string;
  score: string | null;
  reportId: string;
  status: TRIP_REPORT_STATUS;
  ete?: string;
  pax?: string;
  brokers: Array<string>;
}

export interface ITripReportDashboardItem {
  legData: ITripReportLegData;
  reportDetail: null;
}

export interface ITripReportsDashboardResponse {
  status: boolean;
  methodName: string;
  responseCode: number;
  responseMessage: string;
  responseData: {
    content: Array<ITripReportDashboardItem>;
    pageable: {
      sort: {
        empty: boolean;
        sorted: boolean;
        unsorted: boolean;
      };
      offset: number;
      pageNumber: number;
      pageSize: number;
      paged: boolean;
      unpaged: boolean;
    };
    last: boolean;
    totalElements: number;
    totalPages: number;
    size: number;
    sort: {
      empty: boolean;
      sorted: boolean;
      unsorted: boolean;
    };
    first: boolean;
    numberOfElements: number;
    number: number;
    empty: boolean;
  };
  totalRecords: number;
  success: boolean;
}

